import React from 'react'
import { Chip, Typography } from '@mui/material'
import moment from 'moment'

const TEXT_COLOR = '#454545'

export const columns = [
  {
    name: 'id',
    label: 'ID',
    options: {
      display: 'excluded',
      filter: false,
      download: false,
    },
  },
  {
    name: 'recorded',
    label: 'Nombre de colector',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'siteName',
    label: 'Sitio',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'siteType',
    label: 'Tipo de sitio',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'siteParish',
    label: 'Parroquia',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'siteSection',
    label: 'Sección',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'siteAcronym',
    label: 'Acrónimo',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'code',
    label: 'Código',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'specieName',
    label: 'Especie',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'familyName',
    label: 'Familia',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'pseudonym1',
    label: 'Nombre Común',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'pseudonym2',
    label: 'Nombre Común(2)',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'pseudonym3',
    label: 'Nombre Común(3)',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'pseudonym4',
    label: 'Nombre Común(4)',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'dateLog',
    label: 'Fecha de registro',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return <p>{moment(value).utc().format('LL')}</p>
      },
    },
  },
  {
    name: 'treeVerified',
    label: 'Árbol verificado',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        let rol = {
          label: '-',
          color: 'primary',
        }
        switch (value) {
          case true:
            rol = { label: 'Verificado', color: 'primary' }
            break
          case false:
            rol = { label: 'No verificado', color: 'secondary' }
            break
          default:
            break
        }
        return <Chip size="small" label={rol.label} color={rol.color} />
      },
    },
  },
  {
    name: 'alive',
    label: 'Vivo',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'commit',
    label: 'Comentario',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'photo',
    label: 'Foto',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'altitud',
    label: 'Altitud',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'longX',
    label: 'Longitud',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="overline" style={{ color: '#a3429a' }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'latY',
    label: 'Latitud',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="overline" style={{ color: '#a3429a' }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'cap',
    label: 'Circunferencia de fuste',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'dap',
    label: 'Diámetro',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'ht',
    label: 'Altura total',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'hc',
    label: 'Altura comercial',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'copaNS',
    label: 'Tam. copa (NS)',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'copaEW',
    label: 'Tam. copa (EW)',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'follaje',
    label: 'Follaje',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'madurez',
    label: 'Estado de maduréz',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'floracion',
    label: 'Floración',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'fructificacion',
    label: 'Fructificación',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'fusteRectitud',
    label: 'Rectitud de fuste',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'espaciamiento',
    label: 'Espacio de crecimiento',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'calidadRaiz',
    label: 'Raíz',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'calidadFuste',
    label: 'Fuste',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'calidadCorteza',
    label: 'Corteza',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'calidadRamas',
    label: 'Ramas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'calidadHojas',
    label: 'Hojas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'calidadCima',
    label: 'Cima',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'calidadCopa',
    label: 'Copa',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'enfHongos',
    label: 'Hongos',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfTumores',
    label: 'Tumores',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfVieja',
    label: 'Vieja',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfExudados',
    label: 'Exudados',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfDecoloracionHojas',
    label: 'Decoloración de hojas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfPustulasHojas',
    label: 'Pústulas en las hojas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfMuerteRegresiva',
    label: 'Muerte regresiva',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfPudricionRaices',
    label: 'Pudrición de raíces',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfPudricionTronco',
    label: 'Pudrición del tronco',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfPudricionRamas',
    label: 'Pudrición de ramas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfSinIdentificar',
    label: 'Sin identificar',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfUbicRaiz',
    label: 'Raíz',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfUbicFuste',
    label: 'Fuste',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfUbicHojas',
    label: 'Hojas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfUbicCopa',
    label: 'Copa',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfUbicRamas',
    label: 'Ramas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfUbicApices',
    label: 'Ápices',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgHormiga',
    label: 'Hormigas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgOrugasGusanos',
    label: 'Orugas / Gusanos',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgMoscaBlanca',
    label: 'Mosca blanca',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgEscarabajoBarrenador',
    label: 'Escarabajos / Barrenadores',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgCochinilla',
    label: 'Cochinilla / C. algodonosa',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgPulgon',
    label: 'Pulgón',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgMinadorHojas',
    label: 'Minador de las hojas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgAcaros',
    label: 'Ácaros',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgParasitas',
    label: 'Plantas parásitas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgEpifitasLiquines',
    label: 'Epifitas o liquenes',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgSinEspecificar',
    label: 'Sin identificar',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgUbicRaiz',
    label: 'Raíz',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgUbicFuste',
    label: 'Fuste',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgUbicRamas',
    label: 'Ramas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgUbicApices',
    label: 'Ápices',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'plgUbicHojas',
    label: 'Hojas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'probPodaInadecuada',
    label: 'Poda Inadecuada',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'probHeridaTalloRamas',
    label: 'Heridas en tallos o ramas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'probRamasQuebradas',
    label: 'Ramas quebradas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'probRaizDescubierta',
    label: 'Raíces descubiertas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'probDescortezamiento',
    label: 'Descortezamiento',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'probAnillamiento',
    label: 'Anillamiento',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'probClavosAlambres',
    label: 'Clavos o Alambres',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'rsgoCaida',
    label: 'Caida',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'rsgoAfeccionConstr',
    label: 'Afectación a construcciones',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'rsgoInterfCirculacion',
    label: 'Inteferencia con la circulación',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'rsgoInfraestructura',
    label: 'Daño a infraestructura por raíces',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'rsgoRedesElectricas',
    label: 'Interferencia con redes aéreas (eléctricas)',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'recomRiego',
    label: 'Mayor riego',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'recomFertilizacion',
    label: 'Fertilización',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'recomEliminEpifitas',
    label: 'Control de plantas epífitas o parásitas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'recomDanosMecanicos',
    label: 'Tratamiento de daños mecánicos',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'recomElimObjExtranos',
    label: 'Eliminación de objetos extraños en tallo y ramas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'recomPoda',
    label: 'Poda',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'recomDerribo',
    label: 'Derribo',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'recomResiembra',
    label: 'Resiembra',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'recomRContaminantes',
    label: 'Remoción de partículas contaminantes',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        if (value) return <Typography variant="caption">Sí</Typography>
        else if (value === false) return <Typography variant="caption">No</Typography>
        return null
      },
    },
  },
  {
    name: 'enfermOtra',
    label: 'Otras enfermedades',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'enfUbicOtra',
    label: 'Otra ubicación',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'plgOtras',
    label: 'Otras plagas',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'plgUbicOtros',
    label: 'Otros sitios',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'probFisicosOtros',
    label: 'Otros problemas físicos',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'riesgoOtros',
    label: 'Otros riesgos',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
  {
    name: 'recomOtros',
    label: 'Otras recomendaciones',
    options: {
      filter: true,
      download: true,
      customBodyRender: value => {
        return (
          <Typography variant="caption" style={{ color: TEXT_COLOR }}>
            {value}
          </Typography>
        )
      },
    },
  },
]
